import React, { useEffect, useState } from 'react';
import { Layout, useSidebarState, Sidebar, useStore } from 'react-admin';
import CustomAppBar from './CustomAppBar';
import CustomMenu from './CustomMenu';
import type { Partner } from '@src/types';

const HoverSidebar = ({ children }: { children: React.ReactElement }) => {
  const [sidebarOpen, setSidebarOpen] = useSidebarState();
  const [isHovering, setIsHovering] = useState(false);

  // On desktop, expand sidebar on hover when it's collapsed
  const handleMouseEnter = () => {
    if (!sidebarOpen) {
      setIsHovering(true);
      setSidebarOpen(true);
    }
  };

  // On desktop, collapse sidebar when hover ends if it was opened by hover
  const handleMouseLeave = () => {
    if (isHovering) {
      setIsHovering(false);
      setSidebarOpen(false);
    }
  };

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ height: '100%' }}
    >
      <Sidebar>
        {children}
      </Sidebar>
    </div>
  );
};

export const CustomLayout = ({ children }: { children: React.ReactNode }) => {
  const [, setSidebarOpen] = useSidebarState();
  const [currentPartner, setCurrentPartner] = useStore<Partner | null>('currentPartner', null);

  useEffect(() => {
    setSidebarOpen(false); // Set sidebar collapsed by default
  }, [setSidebarOpen]);

  // Initialize currentPartner from sessionStorage if not already set in store
  // This ensures single-partner users have their partner loaded on all pages
  useEffect(() => {
    if (!currentPartner) {
      try {
        const selectedPartner = sessionStorage.getItem('selectedPartner');
        if (selectedPartner) {
          const parsedPartner = JSON.parse(selectedPartner);
          setCurrentPartner(parsedPartner);
        }
      } catch (error) {
        console.error('Failed to initialize partner from sessionStorage:', error);
      }
    }
  }, [currentPartner, setCurrentPartner]);

  return (
    <Layout appBar={CustomAppBar} menu={CustomMenu} sidebar={HoverSidebar}>
      {children}
    </Layout>
  );
};

export default CustomLayout;
